import { Hashes, Tab } from '@/types/hashes';
import { formatHashString, useHashState } from '@/hooks/hashes';

export function useTab(): [Tab, (t: Tab) => void] {
  return useHashState<Tab>(
    (v) => {
      const formated = formatHashString(v);
      switch (formated) {
        case 'item':
          return Tab.ITEM;
        case 'order':
          return Tab.ORDER;
        case 'email':
          return Tab.EMAIL;
        case 'login-id':
          return Tab.LOGIN_ID;
        case 'phone-number':
          return Tab.PHONE_NUMBER;
        default:
          return null;
      }
    },
    Hashes.TAB,
    Tab.ITEM,
  );
}

export function useItemValue(): [string, (v: string) => void] {
  return useHashState(formatHashString, Hashes.ITEM_VALUE, '');
}

export function useOrderValue(): [string, (v: string) => void] {
  return useHashState(formatHashString, Hashes.ORDER_VALUE, '');
}

export function useEmailValue(): [string, (v: string) => void] {
  return useHashState(formatHashString, Hashes.EMAIL_VALUE, '');
}

export function useLoginIdValue(): [string, (v: string) => void] {
  return useHashState(formatHashString, Hashes.LOGIN_ID_VALUE, '');
}

export function usePhoneNumberValue(): [string, (v: string) => void] {
  return useHashState(formatHashString, Hashes.PHONE_NUMBER_VALUE, '');
}

export function useTabValue(): [string, (v: string) => void] {
  const [tab] = useTab();
  const [item, setItem] = useItemValue();
  const [order, setOrder] = useOrderValue();
  const [email, setEmail] = useEmailValue();
  const [loginId, setLoginId] = useLoginIdValue();
  const [phoneNumber, setPhoneNumber] = usePhoneNumberValue();

  switch (tab) {
    case Tab.ITEM:
      return [item, setItem];
    case Tab.ORDER:
      return [order, setOrder];
    case Tab.EMAIL:
      return [email, setEmail];
    case Tab.LOGIN_ID:
      return [loginId, setLoginId];
    case Tab.PHONE_NUMBER:
      return [phoneNumber, setPhoneNumber];
  }
}

export function useItemSection(): [string, (v: string) => void] {
  return useHashState((v) => v, Hashes.SECTION, '');
}
